import { render, staticRenderFns } from "./UserViewPage.vue?vue&type=template&id=11b1fec6&scoped=true&"
import script from "./UserViewPage.vue?vue&type=script&lang=ts&"
export * from "./UserViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./UserViewPage.vue?vue&type=style&index=0&id=11b1fec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b1fec6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VIcon,VSimpleTable})
